import { QuestionnaireType } from "@/encounters/components/EncounterLabor/constants/labor-questionnaires";

/**
 * Questionnaire types that chart birth milestones and default to second-stage labor.
 */
export function isLaborBirthForm(questionnaireName: QuestionnaireType | string): boolean {
  return (
    questionnaireName === QuestionnaireType.Birthing ||
    questionnaireName === QuestionnaireType.ShoulderDystocia ||
    questionnaireName === QuestionnaireType.Resuscitation
  );
}
